import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CampagnesService } from '../../services/requests/campagnes.service';
import { UsersService } from '../../services/requests/users.service';
import * as XLSX from 'xlsx';

declare function showNotif(message: string, type?: string): void;

@Component({
  selector: 'app-campagnes',
  templateUrl: './campagnes.component.html',
  styleUrls: ['./campagnes.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CampagnesComponent implements OnInit {
  nouveauMessage = {
    idClient: '',
    messageUnique: '1',
    nomCampagne: '',
    isScheduled: '0',
    schedule: '',
    message: '',
    tooLong: false,
    date: 0,
    fileName: '',
    fileBase64: ''
  };
  selectedClient: string = '';

  idCampagne = '';
  isAdmin = false;
  isSousAdmin = false;
  clients: any[] = [];
  files: File[] = [];
  upload = false;
  nbImporter = 0;
  isCreating = false;

  error = {
    reference: false,
    message: false,
    destinataire: false,
    schedule: false,
    client: false,
    tooLong: false
  };

  list7Encoding = ['\n', ' ', '@', 'Δ', 'SP', '0', '¡', 'P', '¿', 'p', '£', '_', '!', '1', 'A', 'Q', 'a', 'q', '$', 'Φ', '"', '2', 'B', 'R', 'b', 'r', '¥', 'Γ', '#', '3', 'C', 'S', 'c', 's', 'è', 'Λ', '¤', '4', 'D', 'T', 'd', 't', 'é', 'Ω', '%', '5', 'E', 'U', 'e', 'u', 'ù', 'Π', '&', '6', 'F', 'V', 'f', 'v', 'ì', 'Ψ', '\'', '7', 'G', 'W', 'g', 'w', 'ò', 'Σ', '(', '8', 'H', 'X', 'h', 'x', 'Ç', 'Θ', ')', '9', 'I', 'Y', 'i', 'y', 'LF', 'Ξ', '*', ':', 'J', 'Z', 'j', 'z', 'Ø', '+', ';', 'K', 'Ä', 'k', 'ä', 'ø', 'Æ', ',', '<', 'L', 'Ö', 'l', 'ö', 'CR', 'æ', '-', '=', 'M', 'Ñ', 'm', 'ñ', 'Å', 'ß', '.', '>', 'N', 'Ü', 'n', 'ü', 'å', 'É', '/', '?', 'O', '§', 'o', 'à', '|', '^', '€', '{', '}', '[', ']', '~', '\\'];
  describedText: number[] = [160, 7];

  constructor(
    private route: ActivatedRoute,
    private campagnesService: CampagnesService,
    private usersService: UsersService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.isAdmin = localStorage.getItem('isAdmin') === 'true';
    this.isSousAdmin = localStorage.getItem('isSousAdmin') === 'true';

    if (this.isAdmin || this.isSousAdmin) {
      this.getClients();
    } else {
      this.nouveauMessage.idClient = localStorage.getItem('id') || '';
    }
  }

  getClients(): void {
    this.usersService.getAll().subscribe({
      next: (res: any) => {
        if (res.status && res.data?.users) {
          this.clients = res.data.users.filter((u: any) => u.typeAccount === 'client');
        }
      }
    });
  }

  fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }

  async fileChange(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    this.nouveauMessage.fileName = file.name;
    this.nouveauMessage.fileBase64 = '';
    this.nbImporter = 0;

    try {
      const base64 = await this.fileToBase64(file);
      const base64Data = base64.split(',')[1];
      this.nouveauMessage.fileBase64 = base64Data;
      
      await this.compterLignesFichier(file);

    } catch (error) {
      this.nouveauMessage.fileName = '';
      this.nouveauMessage.fileBase64 = '';
      this.nbImporter = 0;
    }
  }

  async compterLignesFichier(file: File): Promise<void> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = e.target?.result;
          if (data) {
            const workbook = XLSX.read(data, { type: 'array' });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(sheet, { defval: '' });
            this.nbImporter = Array.isArray(rows) ? rows.length : 0;
          } else {
            this.nbImporter = 0;
          }
        } catch (error) {
          this.nbImporter = 0;
        }
        resolve();
      };
      reader.onerror = () => {
        this.nbImporter = 0;
        resolve();
      };
      reader.readAsArrayBuffer(file);
    });
  }

  control7Encoding(): void {
    this.describedText = [160, 7];
    for (const char of this.nouveauMessage.message) {
      if (!this.list7Encoding.includes(char)) {
        this.describedText = [70, 16];
        break;
      }
    }
  }

  compterTaille(): number {
    this.nouveauMessage.tooLong = this.nouveauMessage.message.length > this.describedText[0];
    return this.nouveauMessage.message.length;
  }

  async premiereCreation(): Promise<void> {
    if (this.isAdmin || this.isSousAdmin) {
      this.nouveauMessage.idClient = this.selectedClient;
    }
    
    const m = this.nouveauMessage;
    
    if (m.messageUnique === '0' && m.fileName && !m.fileBase64) {
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
    
    if (m.messageUnique === '0' && (!m.fileName || !m.fileBase64)) {
      this.error = {
        client: !m.idClient,
        reference: !m.nomCampagne,
        message: false,
        schedule: m.isScheduled === '1' && !m.schedule,
        destinataire: true,
        tooLong: m.tooLong
      };
      return;
    }
    
    this.error = {
      client: !m.idClient,
      reference: !m.nomCampagne,
      message: m.messageUnique === '1' && !m.message,
      schedule: m.isScheduled === '1' && !m.schedule,
      destinataire: false,
      tooLong: m.tooLong
    };

    if (!Object.values(this.error).includes(true)) {
      this.add();
    }
  }

  add(): void {
    const m = this.nouveauMessage;
    const campaignData: any = {
      idClient: m.idClient?.trim() || '',
      nomCampagne: m.nomCampagne?.trim() || '',
      messageUnique: m.messageUnique,
      isScheduled: m.isScheduled,
      schedule: m.isScheduled !== '1' ? new Date().toISOString() : m.schedule,
      date: Date.now(),
      fileName: m.fileName || '',
      fileBase64: m.fileBase64 || '',
      message: m.messageUnique === '1' ? (m.message?.trim() || '') : 'Message différent par destinataire'
    };

    const champsManquants: string[] = [];
    if (!campaignData.idClient) champsManquants.push('idClient');
    if (!campaignData.nomCampagne) champsManquants.push('nomCampagne');
    if (!campaignData.message) champsManquants.push('message');
    if (!campaignData.fileBase64) champsManquants.push('fileBase64');
    if (!campaignData.fileName) champsManquants.push('fileName');
    if (!campaignData.date) champsManquants.push('date');
    if (campaignData.isScheduled === '1' && !campaignData.schedule) champsManquants.push('schedule');

    if (champsManquants.length > 0) {
      alert(`Champs requis manquants : ${champsManquants.join(', ')}`);
      return;
    }

    this.isCreating = true;
    this.campagnesService.add(campaignData).subscribe({
      next: (response: any) => {
        this.isCreating = false;
        if (response.status) {
          const nbLignes = response.data?.nbLignes || this.nbImporter || 0;
          const messageLignes = nbLignes > 0 ? ` (${nbLignes} lignes détectées)` : '';
          showNotif(`Campagne créée avec succès${messageLignes}`, 'success');
          this.idCampagne = response.data?.idCampagne || response.data?.id || '';
          setTimeout(() => this.router.navigate(['/suivi']), 1000);
        } else {
          showNotif(response.message || "Erreur lors de la création de la campagne.", 'error');
        }
      },
      error: (error: any) => {
        this.isCreating = false;
        showNotif(error?.error?.message || "Erreur inconnue lors de la création.", 'error');
      }
    });
  }
}
